// extracted by mini-css-extract-plugin
export var assigneeBadge = "_lm-0";
export var assigneeDetails = "_lm-1";
export var assigneeInfo = "_lm-2";
export var dropdownContainer = "_lm-4";
export var dropdownImage = "_lm-5";
export var editAssigneeInfo = "_lm-3";
export var editAssigneeModalContainer = "_lm-6";
export var hidden = "_lm-8";
export var input = "_lm-7";